import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { useDocumentTitle } from '../../../app/hooks/use-document-title';
import { ProviderList } from './ProviderList';

export function HealthcareEntityProviderList() {
  useDocumentTitle('Healthcare Organization Providers');
  return (
    <>
      <div className="bg-primary-dark">
        <Container className="page-header-title pb-2">
          <h1>Providers</h1>
        </Container>
      </div>
      <div style={{ position: 'relative' }}>
        <div className="bg-primary-dark d-block provider-list-header" />
      </div>
      <Container>
        <Row className="justify-content-center" xs={12}>
          <Col>
            <ProviderList />
          </Col>
        </Row>
      </Container>
    </>
  );
}
